<template>
	<section class="news-popup">
		<div class="news-popup__header">
			<img
				:src="`${pathImages}/popups/news-img.avif`"
				class="popup__img"
			/>
			<DividerLine />
		</div>
		<div class="news-popup__content">
			<div class="news-popup__title">
				{{ news.title }}
			</div>
			<div class="news-popup__date">
				{{ formatDate(news.date) }}
			</div>
			<ScrollFade>
				<template #scrollContent>
					<div class="news-popup__text" v-html="news.text" />
				</template>
			</ScrollFade>
		</div>
	</section>
</template>

<script lang="ts" setup>
import DividerLine from "@/components/SVG/DividerLine.vue";
import ScrollFade from "@/components/ScrollFade.vue";
import { formatDate } from "@/utils/format";
import { pathImages } from "@/utils/url";

interface Props {
	news: { text: string; title: string; date: Date };
}
const { news } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.news-popup {
	@include flex-col-center;
	gap: 0.85rem;
	&__header {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}
	&__content {
		padding-bottom: 1rem;
		width: 100%;
	}
	&__title {
		color: #f4d278;
		font-weight: bold;
		font-size: 1.25rem;
		text-align: center;
		@include background(
			url($path-images + "popups/news-title-bg.avif"),
			100% 100%,
			center,
			no-repeat
		);
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
		margin-bottom: 0.438rem;
		padding-bottom: 0.25rem;
		width: 98%;
		height: 1.875rem;
		line-height: 1.2rem;
	}

	&__date {
		margin-bottom: 0.5rem;
		color: #f2dcb5;
		font-weight: bold;
		font-size: 0.813rem;
		text-align: center;
	}

	&__text {
		padding: 0 1rem;
		max-height: 18rem;
		color: #fff3dd;
		font-size: 0.906rem;
		word-wrap: break-word;
	}

	.popup__img {
		width: 100%;
		object-fit: cover;
	}

	:deep(.divider-line) {
		position: absolute;
		left: 0;
		width: 100%;
	}

	:deep(ul) {
		margin-left: 1rem;
	}

	:deep(a) {
		cursor: pointer;
		color: #f2dcb5;
		text-decoration: underline;
	}
}
</style>
